import { render, staticRenderFns } from "./taking.vue?vue&type=template&id=540f37a8&scoped=true&"
import script from "./taking.vue?vue&type=script&lang=js&"
export * from "./taking.vue?vue&type=script&lang=js&"
import style0 from "./taking.vue?vue&type=style&index=0&id=540f37a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540f37a8",
  null
  
)

export default component.exports